import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// If an access token has expired but a valid refresh token cookie still exists, silently
// refresh once and retry the original request instead of forcing the user to log in again.
// This is what makes "stay signed in" actually persistent across long idle periods.
let refreshPromise = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (response?.status === 401 && !config._retried && !config.url?.includes("/auth/")) {
      config._retried = true;
      try {
        refreshPromise = refreshPromise || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        await refreshPromise;
        refreshPromise = null;
        return api(config);
      } catch {
        refreshPromise = null;
      }
    }
    return Promise.reject(error);
  }
);

export function wsUrl(gameId, token) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws/${gameId}?token=${encodeURIComponent(token || "")}`;
}

export function raidWsUrl(raidId, token) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/raids/ws/${raidId}?token=${encodeURIComponent(token || "")}`;
}

export function gameShowWsUrl(showId, token) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/game-shows/ws/${showId}?token=${encodeURIComponent(token || "")}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(fileId) {
  if (!fileId) return null;
  return `${API}/uploads/${fileId}`;
}
